module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_yale-aa9fa13ed62e5ff8242986f3b92510aa.png";